import { API } from '@/modules/api'
import { ref, type Ref } from 'vue'

// Shared reactive reference for app bar data - ALL components will use this same ref
export const appBarDataRef: Ref<any> = ref(null)

let fetchPromise: Promise<any> | null = null
let isFetching = false

export const getAppBarData = async (): Promise<any> => {
  // If already loaded, return it
  if (appBarDataRef.value !== null) {
    return appBarDataRef.value
  }

  // If currently fetching, return the existing promise
  if (fetchPromise !== null) {
    return fetchPromise
  }

  // Start fetching
  isFetching = true
  fetchPromise = API.Get.appBar()
    .then(data => {
      appBarDataRef.value = data // Update the shared reactive ref
      isFetching = false
      return data
    })
    .catch(error => {
      console.error('appBarCache: Error fetching app bar data:', error)
      fetchPromise = null // Reset so it can be retried
      isFetching = false
      throw error
    })

  return fetchPromise
}
